import type React from 'react';

import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';

import { useStyles } from 'components/panels/avoidance/styles';
import { BodyLarge } from 'components/typography/Typography';
import { type PlainAvoidanceRuleInterface } from 'typedefs/avoidance';

interface AvoidanceRulesAndGroupsPanelProps {
  avoidanceRules: PlainAvoidanceRuleInterface[];
  setAvoidanceRules: (avoidanceRule: PlainAvoidanceRuleInterface) => void;
}

const AvoidanceRulesPanel: React.FC<React.PropsWithChildren<AvoidanceRulesAndGroupsPanelProps>> = ({
  avoidanceRules,
  setAvoidanceRules,
}) => {
  const { classes } = useStyles();
  return (
    <Grid container className={classes.panelWrapper} direction="column">
      {avoidanceRules?.map((rule) => (
        <Grid key={rule.name} item>
          <Grid container direction="row">
            <Grid item>
              <Checkbox checked={rule.checked} color="primary" onChange={() => setAvoidanceRules(rule)} />
            </Grid>
            <Grid item className={classes.nameWrapper}>
              <BodyLarge>{rule.name}</BodyLarge>
            </Grid>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default AvoidanceRulesPanel;
